@if (isAddDirectBookingEnabled$ | async) {
  <sbnb-button
    label="+ Add booking"
    [size]="size"
    [type]="type"
    [fullWidth]="fullWidth"
    [matMenuTriggerFor]="menu"
    [ngStyle]="{ width: fullWidth ? '100%' : 'auto' }"></sbnb-button>
  <mat-menu #menu>
    <div class="manual-booking-menu-item clickable flex flex-col gap-1" (click)="openDirectDialog()">
      <span class="night-darker strong">Add a Direct booking</span>
      <span class="text__xsmall">Hospitable will collect payment from the guest.</span>
    </div>
    <div class="manual-booking-menu-item clickable flex flex-col gap-1" (click)="openDialog()">
      <span class="night-darker strong">Add a manual booking</span>
      <span class="text__xsmall">I will manage any payments off-platform</span>
    </div>
    <div
      *ngIf="ownerStaysEnabled$ | async"
      class="manual-booking-menu-item clickable flex flex-col gap-1"
      [routerLink]="['/booking-flows/owner-stay']"
      [queryParams]="ownerStayRouterQueryParams">
      <span class="night-darker strong">Add an owner stay</span>
      <span class="text__xsmall">Simplified owner stay: block dates, send confirmation, optional lock code</span>
    </div>
  </mat-menu>
} @else {
  <sbnb-button
    label="+ Add booking"
    [size]="size"
    [type]="type"
    [fullWidth]="fullWidth"
    (click)="openDialog()"
    [ngStyle]="{ width: fullWidth ? '100%' : 'auto' }"></sbnb-button>
}
